import React from 'react';
import IFlightRangeData from '../../types/FlightRanges';
import IReplacementRange from '../../types/ReplacementRange';

interface FlightRangeModifyTableProps {
  title: string;
  ranges: IFlightRangeData[] | IReplacementRange[];
  showRemoveButton?: boolean;
  onRemove?: (id: string) => void;
}

const FlightRangeModifyTable: React.FC<FlightRangeModifyTableProps> = ({
  title,
  ranges,
  showRemoveButton = false,
  onRemove
}) => {
  const rangeCount = ranges.length;
  return (
    <div>
      <h2 className='flight-range-modify__selected'>{title} ({rangeCount})</h2>
      <table className="flight-range-modify__table" aria-label={`${title} table`}>
        <thead>
          <tr>
            <th scope="col">MKT. CARRIER</th>
            <th scope="col">FLIGHT RANGE</th>
            <th scope="col">OP. CARRIER</th>
            <th scope="col">FLIGHT TYPE</th>
            <th scope="col">EFFECTIVE</th>
            <th scope="col">DISCONTINUED</th>
            {showRemoveButton && <th scope="col" aria-hidden="true"></th>}
          </tr>
        </thead>
        <tbody>
          {ranges.map(range => (
            <tr
              key={range.id}
              // Using the original ID from the API
              data-id={range.id}
            >
              <td>{range.marketingCarrier}</td>
              <td>{`${range.start} - ${range.end}`}</td>
              <td>{range.operatingCarrier}</td>
              <td>{range.flightTypeDescription}</td>
              <td className="flight-range-modify__effective-date">
                {range.effectiveDate}
              </td>
              <td className="flight-range-modify__discontinued-date">
                {range.discontinueDate}
              </td>
              {showRemoveButton && (
                <td>
                  <button
                    className="flight-range-modify__remove-link"
                    onClick={() => onRemove && onRemove(range.id)}
                    type="button"
                    aria-label={`Remove flight range ${range.start} - ${range.end}`}
                  >
                    Remove
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FlightRangeModifyTable;
